export var theme = {
    palette: {
        text: '#ffffff',
        background: '#09080d',
        headerBackground: '#121212',
        purple: '#8047ff',
        gold: '#cca768',
        bonus: '#00f29B',
        valid: '#269e50',
        error: '#fd5859',
        warning: '#ff6f50',
        disabled: '#707071',
        layoutCard: '#27232a',
        layoutCardLight: '#4B4252',
        layoutCardStroke: '#37303b',
        layoutNeutralDark: '#110e12',
        layoutNeutral: '#161318',
        layoutFieldNeutral: '#2f2d3c',
        button: {
            highlighted: '#ffbe44',
            alternative: '#2b2350',
            warning: '#72314f',
            default: '#221932',
        },
    },
};
